/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { useMemo, useCallback } from 'react';
import { getBaseUrl } from '../../Account-managementApiEnvironment';
import { useMutation, ErrorTypes } from '@cbhq/instant-api-hooks-core/fetch';
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

import {
  CoinbaseEngUsersAccountManagementApiApiUpdateConsensusRuleRequest,
  getCoinbaseEngUsersAccountManagementApiApiUpdateConsensusRuleRequestErrors,
} from '../../types/coinbase/eng/users/account_management/api/api/CoinbaseEngUsersAccountManagementApiApiUpdateConsensusRuleRequest';
import {
  CoinbaseEngUsersAccountManagementApiApiUpdateConsensusRuleResponse,
  getCoinbaseEngUsersAccountManagementApiApiUpdateConsensusRuleResponseErrors,
} from '../../types/coinbase/eng/users/account_management/api/api/CoinbaseEngUsersAccountManagementApiApiUpdateConsensusRuleResponse';

export type UpdateConsensusRuleArgs = {
  /**
   * entity_id is the entity scope.
   */
  entityId: string;

  /**
   * rule_id is the URL-encoded composite sort key identifying the rule.
   */
  ruleId: string;
};

type AllUpdateConsensusRuleMutationArgs =
  CoinbaseEngUsersAccountManagementApiApiUpdateConsensusRuleRequest;
export type UpdateConsensusRuleMutationArgs = Omit<
  AllUpdateConsensusRuleMutationArgs,
  'entityId' | 'ruleId'
>;

export type UpdateConsensusRuleResult =
  CoinbaseEngUsersAccountManagementApiApiUpdateConsensusRuleResponse;

const validateUpdateConsensusRuleResult = (value: unknown) => {
  const errors = getCoinbaseEngUsersAccountManagementApiApiUpdateConsensusRuleResponseErrors(value);
  if (errors.length) {
    console.error(
      CONSOLE_PREFIX,
      CONSOLE_STYLE,
      `API Error: UpdateConsensusRuleResult data does not match contract.`,
      errors,
    );
  }
};

type HookReturnType = (
  params: UpdateConsensusRuleArgs,
  payload: Readonly<UpdateConsensusRuleMutationArgs>,
  options?: RequestInit,
) => Promise<UpdateConsensusRuleResult | ErrorTypes>;

export const getUpdateConsensusRuleUrl = (params: UpdateConsensusRuleArgs) => {
  const searchParams = new URLSearchParams();
  const url = `${getBaseUrl()}/v1/consensus/entities/${params.entityId}/rules/${params.ruleId}${
    searchParams.toString() === '' ? '' : `?${searchParams}`
  }`;
  return url;
};

/**
 * Put UpdateConsensusRule
 * @Url /v1/consensus/entities/{entity_id}/rules/{rule_id}
 * @Auth Required
 */
export const useUpdateConsensusRule = (): HookReturnType => {
  const mutation = useMutation<unknown, UpdateConsensusRuleResult>();

  const callback = useCallback(
    async (
      params: UpdateConsensusRuleArgs,
      payload: Readonly<UpdateConsensusRuleMutationArgs>,
      options?: RequestInit,
    ) => {
      const postBody = {
        required_approvals: payload.requiredApprovals,
        consensus_2fa_type: payload.consensus2faType,
        version: payload.version,
        rule_name: payload.ruleName,
        approver_roles: payload.approverRoles,
        enabled_status: payload.enabledStatus,
      };

      const init = { ...(options || {}), method: 'PUT' };

      const url = getUpdateConsensusRuleUrl(params);
      const result = await mutation(url, postBody, init);
      if (process.env.NODE_ENV !== 'production') {
        validateUpdateConsensusRuleResult(result);
      }
      return result;
    },
    [mutation],
  );

  return callback;
};
